module.exports = __webpack_public_path__ + "assets/favicons/android-chrome-192x192.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=assets/favicons/[name].[ext]!./client/app/assets/favicons/android-chrome-192x192.png
// module id = 1233
// module chunks = 1